import React, {Component} from 'react';

class OrderListItem extends Component {
  render() {
    const {name, orderNum, imgURL, price} = this.props;
    let unitPrice = price/orderNum
    unitPrice = unitPrice/orderNum
    return(
      <div className="OrderListItem">
        <div className="OrderListImg"> <img src={imgURL} alt={name} /> </div>
        <div className="OrderListImgCaption">
          <div> {name} </div>
          <div className="OrderListPrice"> <span> $ {unitPrice} </span> </div>
          <div> x{orderNum} </div>
        </div>
      </div>
    );
  }
}

export default OrderListItem;



// WEBPACK FOOTER //
// ./src/components/orderPage3/orderListItem.js